export const PASSWORD_RULE = {
  pattern: /^.{10,}$/,
  message: 'Minimum 10 characters are required',
}
